import { render, staticRenderFns } from "./InvSearchFixed.vue?vue&type=template&id=0ff12dea&"
import script from "./InvSearchFixed.vue?vue&type=script&lang=js&"
export * from "./InvSearchFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports